import { Injectable } from "@angular/core";
import { OrderResponse, ProfileInfo } from "@sgm-frontend/core";
import { BehaviorSubject } from "rxjs";
import { ForgotDataTransfer, ForgotTokenTransfer } from "../../inputs/user.input";


@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private emailSource = new BehaviorSubject<ForgotDataTransfer | null>(null);
  private forgotSource = new BehaviorSubject<ForgotTokenTransfer | null>(null);
  private userSource = new BehaviorSubject<any | null>(null);
  private orderSource = new BehaviorSubject<OrderResponse | null>(null);
  email$ = this.emailSource.asObservable();
  forgot$ = this.forgotSource.asObservable();
  orderData$ = this.orderSource.asObservable();
  SetEmail(data: ForgotDataTransfer) {
    this.emailSource.next(data);
  }
  SetToken(data: ForgotTokenTransfer) {
    this.forgotSource.next(data);
  }
  SetUserInfo(user: any) {
    this.userSource.next(user);
  }

  ClearEmail() {
    this.emailSource.next(null);
  }
  SetOrder(data: OrderResponse) {
    this.orderSource.next(data);
  }
}